<template>
  <div class="article-page">
    <PageTitle :title="t('articles')" />
    <div class="wrapper" style="padding-bottom: 0px!important;">
      <div class=" article-preview pa-4 ma-4 mt-4">
        <h3>Фильтры:
          <span class="ml-2" v-if="selectedFilters && selectedFilters.length>0">
            <v-chip
              closable
              label
              @click.close="selectedFilters=[]"
            >
              {{selectedFilters.length}}
            </v-chip>
          </span>
        </h3>

        <v-sheet class="py-4 px-1">
          <v-chip-group
            selected-class="v-chip--selected v-chip--variant-tonal text-pink-lighten-1"
            variant="outlined"
            multiple
            column
            v-model="selectedFilters"
          >
            <v-chip
              class="short"
              label
              :ripple="false"
              v-for="tag in activeTags"
              :key="tag.id"
            >
              <span>{{tag.tagName}}</span>
            </v-chip>
          </v-chip-group>
        </v-sheet>
      </div>
    </div>

    <StateWrapper
      :content="data.news"
      :loadingStatus="loadingStatus"
      :checkLogin="false"
    >
      <div class="wrapper">
        <div class="article-preview ma-4"  v-for="(v, idx) in data.news" :key="idx">
          <div class="article-preview__content">
            <AppTitle mode="h3">
              <template v-slot:title>{{ v.title }}</template>
            </AppTitle>
            <v-divider class="mt-2 mb-2"></v-divider>
            <p v-if="v.newsAnnotation.length">{{ v.newsAnnotation }}</p>
            <div v-if="v.newsTags && v.newsTags.length>0" class="ma-2">
              <h3>Ярлыки:</h3>
              <div class="help-page__chips">
                <span v-for="c in v.newsTags" :key="c.id">{{c.tagName}}</span>
              </div>
            </div>
            <SalonMetaData :data="{ date: v.publDateTime }" />
            <div class="article-preview__bottom">
              <router-link  :to="`/article/${v.id}`">Читать далее</router-link>
            </div>
          </div>
        </div>
        <div class="flex flex__jc-c" v-if="!!data && data.news">
          <vue-awesome-paginate
            :total-items="data.newsCount"
            v-model="currentPage"
            :items-per-page="itemsPerPage"
            :max-pages-shown="maxPagesShown"
            @click=updateArticles()
          />
        </div>
      </div>
    </StateWrapper>
  </div>
</template>
  
<script>
  import { t } from "@/utils/translate";
  import { ref, onMounted, watch } from "vue";
  import { customAxios } from "@/service/customAxios";
  import PageTitle from "@/elements/PageTitle.vue";
  import AppTitle from "@/elements/AppTitle.vue";
  import StateWrapper from "@/components/StateWrapper.vue";
  import SalonMetaData from "@/components/SalonMetaData.vue";
  import { usePagination } from "@/composables/usePagination";

  export default {
    components: { PageTitle, AppTitle, StateWrapper, SalonMetaData },

    setup() {
      const articles = ref([]);
      const filters = ref([]);
      const data = ref({});
      const activeTags = ref([]);
      const selectedFilters = ref([]);
      const maxPagesShown = ref(5);
      const itemsPerPage = ref(6);
      const currentPage = ref(1);
      const loadingStatus = ref("loading");

      const { getSlicedArray } = usePagination();

      const currentFilters = ref([]);

      function clearFilters() {
        currentFilters.value = []
      }

      function toggleFilters(f) {
        const existedIndex = currentFilters.value.findIndex((v) => v.id === f.id);
        if (existedIndex === -1) {
          currentFilters.value.push(f);
        } else {
          currentFilters.value.splice(existedIndex, 1);
        }
      }

      function getObjectsByIndexes(objects, indexes) {
        return indexes.map(index => objects[index]);
      }

      async function getNewsTags() {
        try {
          const r = await customAxios.get("news/tag/published");
          if (r.status === 200) {
            activeTags.value = r.data;
          }
        } catch (e) {
          console.log(e);
        }
      }

      function formatDate(dateString) {
        let formatter = new Intl.DateTimeFormat("ru", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });

        return capitalizeFirstLetter(formatter.format(Date.parse(dateString)));
      }
      
      function capitalizeFirstLetter(string) {
        if(string && string.length>0){
          return string.charAt(0).toUpperCase() + string.slice(1);
        } else {
          return ''
        }
      }

      async function getArticles() {
        loadingStatus.value = "loading";
        try {
          const r = await customAxios.post("news/published/paginated",{
            page: currentPage.value,
            notePerPage: itemsPerPage.value,
            newsTags: selectedFilters.value && selectedFilters.value.length > 0 ? getObjectsByIndexes(activeTags.value, selectedFilters.value) : []
          });
          loadingStatus.value = "loaded";
          return r.data;
        } catch (e) {
          loadingStatus.value = "error";
          console.log(e);
        }
      }

      onMounted(async () => {
        data.value = await getArticles();
      });
      onMounted(async () => {
        await getNewsTags();
      });
      
      async function updateArticles() {
        data.value = await getArticles();
        articles.value = data.value.news;
      }

      watch( () => selectedFilters.value, async () => {
        data.value = await getArticles();
      }, { deep: true });

      return {
        clearFilters,
        loadingStatus,
        getSlicedArray,
        itemsPerPage,
        currentPage,
        maxPagesShown,
        articles,
        t,
        filters,
        toggleFilters,
        currentFilters,
        updateArticles,
        data,
        formatDate,
        activeTags,
        selectedFilters
      };
    },
  };
</script>

  <style lang="scss">
  @import "@/styles/paginations.scss";
  .short{
    min-width:max-content;
  }
  .short span{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .article-preview {
  position: relative;
  border-radius: 8px;
  box-shadow: $shadow-2;

  &__chips {
    flex-wrap: wrap;
    justify-content: center;
    font-weight: 700;
  }

  &__chip {
    border: 2px solid rgba($text, 0.1);
    padding: 8px;
    border-radius: 16px;
    margin: 8px;
    text-transform: uppercase;

    & + .article-preview__chip {
      margin-left: 16px;
    }
  }



  &__content {
    height: 100%;
    padding: 16px;
    padding-top: 40px;
    display: grid;
    grid-gap: 40px;
    grid-template-rows: max-content max-content 1fr max-content min-content;
  }

  &.public .article-preview__content {
    grid-template-rows: max-content max-content 1fr max-content;
  }

  &__bottom {
    padding: 16px;

    a,
    button {
      text-decoration: none;
      color: #fff;
      background-color: $accent-1;
      padding: 8px;
      width: 100%;
      display: flex;
      justify-content: center;
      border-radius: 8px;
      font-size: 20px;
      line-height: 30px;
      transition: all 0.2s;

      &:hover {
        background-color: rgba($accent-1, 0.8);
      }

      &:active {
        transform: scale(1.01);
      }
    }

    a,
    button {
      &:nth-child(2n) {
        margin-top: 16px;
        background-color: $accent-2;

        &:hover {
          background-color: rgba($accent-2, 0.8);
        }
      }
    }
  }

  &__admin {
    border-top: 1px solid rgba($text, 0.1);
    padding-top: 20px;
  }
}
  .article-page {
    position: relative;

    .wrapper {
      @include page;
    }

    &__links {
      margin-top: 40px;
    }

    &__link {
      position: relative;
      border-radius: 8px;
      background-color: rgba($text, 0.1);
      text-decoration: none;
      color: $text;
      display: block;
      padding: 32px 16px;
      box-sizing: border-box;

      h4,
      p {
        margin-bottom: 40px;
      }
    }

    .article-page__methods {
      p {
        margin: 0 0 16px 0;
        padding-left: 8px;
        font-weight: 700;
      }

      ul {
        display: flex;
        flex-wrap: wrap;
      }

      li {
        @include flex-center;
        background-color: $accent-1;
        color: #fff;
        display: inline-block;
        vertical-align: baseline;
        padding: 8px;
        border-radius: 8px;
        margin: 8px;
      }
    }

    &__link + .article-page__link {
      margin-top: 30px;
    }
  }
  </style>
